import {cs} from "../../../../../../../../../react/chain-services";
import * as React from "react";
import "./expansion.scss";
import {UseState} from "../../../../../../../../../react/use-state";
import {cx} from "emotion";
import {Checkbox} from "../../../../../../../common/design2/checkbox/checkbox";
import {toColumns, toggleE} from "../../../../../../../../../utils/collections";
import {ConfirmDialog} from "../../../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {onChangeState} from "../../../../../../../../../react/on-change-state";

export const Expansion = ({addresses, addressCount=undefined, grey, onRemove, onClose}) => cs(
    ["errorRemoveAll", (_, next) => UseState({next})],
    ["selecteds", ({errorRemoveAll}, next) => UseState({
        initValue: [],
        next: (state) => next(onChangeState({
            state,
            onChange: () => errorRemoveAll.onChange(null),
        })),
    })],
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ({selecteds, confirmDialog, errorRemoveAll}) => (
        <div className={cx("expansion-4dc", {grey})}>
            <div className="content">
                {toColumns(addresses, 2).map((column, ci) => (
                    <div className="column" key={ci}>
                        {column.map((a, i) => (
                            <div
                                className="item" key={i}
                                onClick={() => selecteds.change((_) => toggleE(a.key, _))}
                            >
                                <div className="checkbox">
                                    {Checkbox({
                                        checked: selecteds.value.includes(a.key),
                                        xdQaName: a.label
                                    })}
                                </div>
                                <div className="label highlighted-48d" xd-qa-type="label" xd-qa-name={a.label}>
                                    {a.label}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            <div className="footer">
                {errorRemoveAll.value && (
                    <div className="error" xd-qa-type="text" xd-qa-name="Coop Condo List Remove All Error">
                        Cannot remove all addresses
                    </div>
                )}
                <button
                    className={cx("remove", {disabled: selecteds.value.length === (addressCount ?? addresses.length)})}
                    disabled={!selecteds.value.length}
                    onClick={async () => {

                        if (selecteds.value.length === (addressCount ?? addresses.length)) {
                            errorRemoveAll.onChange(true);
                            return;
                        }

                        const confirm = await confirmDialog.show({
                            actionName: "remove",
                            message: "Remove the address(es) from building?",
                        })
                        if (confirm) {
                            onRemove(selecteds.value);
                            selecteds.onChange([]);
                        }
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Coop Condo List Remove Selected"
                >
                    REMOVE SELECTED
                </button>

                <button
                    className="close"
                    onClick={onClose}
                    xd-qa-type="button"
                    xd-qa-name="Coop Condo List Addresses Close"
                >
                    CLOSE
                </button>
            </div>
        </div>
    ),
);

